export const ERROR_MESSAGES = {
  SECTION_NOT_FOUND: 'Section not found',
  SECTION_NOT_FOUND_WITH_SUGGESTIONS: 'Section not found. Here are the closest matches:',
  PARSE_ERROR: 'Failed to parse document',
  INVALID_FORMAT: 'Invalid document format',
  INVALID_LEVEL: 'Invalid header level',
  INVALID_SECTION_OPTIONS: 'Invalid section extraction options',
  AMBIGUOUS_MATCH: 'Multiple potential matches found for section'
} as const;

export type ErrorCode = keyof typeof ERROR_MESSAGES; 